<template>
    <div class="invoices_section">
        <i class="uis uis-invoice"></i>
        <h2>Invoices</h2>
        <h2>This section is under construction</h2>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.invoices_section {
    padding-top: 2rem;

    i {
        font-size: 2rem;
    }
}
</style>